// @flow
import {
  SHOP_SHIPPING_REQUEST,
  SHOP_SHIPPING_SUCCESS,
  SHOP_SHIPPING_FAILURE,
  SHOP_SHIPPING_CLEAR,
  SHOP_SHIPPING_CURRENT,
  SHOP_SHIPPING_LOCK,
} from 'app/common/actions/shop/order/shipping';


type DefaultState = {
  data: Array<{
    id: number,
    name: string,
    shippingMethodType: number,
  }>,
  loading: boolean,
  currentShippingId: ?number,
  shippingMethodType: ?number,
  lockedShippingIds: [],
}

const defaultState: DefaultState = {
  data: [],
  loading: true,
  currentShippingId: null,
  shippingMethodType: null,
  lockedShippingIds: [],
};

// $FlowFixMe
const shipping = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_SHIPPING_REQUEST: {
      return { ...state, loading: true };
    }

    case SHOP_SHIPPING_SUCCESS: {
      return { ...state, ...payload, lockedShippingIds: [], loading: false };
    }

    case SHOP_SHIPPING_FAILURE: {
      return defaultState;
    }

    case SHOP_SHIPPING_CLEAR: {
      return defaultState;
    }

    case SHOP_SHIPPING_CURRENT: {
      return { ...state, ...payload };
    }

    case SHOP_SHIPPING_LOCK: {
      return { ...state, lockedShippingIds: [...state.lockedShippingIds, payload] };
    }

    default:
  }
  return state;
};

export default shipping;
